export const PAGE_LINKS = {
	Новости: '#',
	Статистика: '#',
	'О нас': '#',
};

export const NO_AUTH_PAGES = ['/login', '/register'];
